import type { InheritanceCircuit } from '@shared/services/transmission/types'
import { zipObject } from 'src/tpbp-core/utils/common.utils'
import { type JsonApiResponse } from '../json-api/json-api.types'
import { type InheritanceWeirdLever } from '../request.types'

function getLeverOrdersByName(circuit: InheritanceCircuit) {
  const list = Object.values(circuit.suggested_lever_order ?? {})
  return zipObject<Record<string, number>>(list, (index) => index)
}

function getIncludedLevers(circuit: InheritanceCircuit) {
  const leversOrdersByName = getLeverOrdersByName(circuit)
  return circuit.levers.reduce<InheritanceWeirdLever[]>(
    (includedLevers, lever) => {
      if (lever.type === 'levers') {
        const order = leversOrdersByName[lever.name]
        const data = { ...lever, order }
        includedLevers.push(data)
      }
      return includedLevers
    },
    [],
  )
}

export function leversMapper(response: JsonApiResponse<InheritanceCircuit[]>) {
  const firstCircuit = response.data?.[0]
  if (firstCircuit === undefined) return []
  const includedLevers = getIncludedLevers(firstCircuit)
  return includedLevers
}
